import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class ChangePrioFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangePrioFilter';

    public constructor(public id: number) {
        super(ChangePrioFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangePrioFilter): void => {
    if (state.filterState.prioIds.includes(action.id)) {
        state.filterState.prioIds = state.filterState.prioIds.filter(x => x != action.id);
    }
    else {
        state.filterState.prioIds.push(action.id);
    }
};

//@ts-ignore
registerReducer(ChangePrioFilter.ACTION_TYPE, reducer);